import { render, staticRenderFns } from "./ApplicantsTable.vue?vue&type=template&id=caf12040&scoped=true&"
import script from "./ApplicantsTable.vue?vue&type=script&lang=js&"
export * from "./ApplicantsTable.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantsTable.vue?vue&type=style&index=0&id=caf12040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf12040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
